import api from "../configs/axios.config";

export const quickQuoteEndpoints = {
  create: (data) => api.post("/v1/quick-quote", data),
  update: (id, data) => api.put(`/v1/quick-quote/${id}`, data),
  getAll: () => api.get("/v1/quick-quote"),
  getById: (id) => api.get(`/v1/quick-quote/${id}`),
  delete: (id) => api.delete(`/v1/quick-quote/${id}`),
};
